<template>
  <button class="text-primary-60 flex items-center space-x-2 text-sm">
    <span v-show="parentCode">
      {{ parentCode }}
    </span>
    <ChevronRightIcon v-show="parentCode" class="h-5 w-5" />
    <span :class="[isHomePage ? 'text-neutral-0' : 'text-neutral-0']">
      {{ session.account.code }}
    </span>
    <SwitchHorizontalIcon class="h-5 w-5" />
  </button>
</template>

<script lang="ts" setup>
// Icons
import { SwitchHorizontalIcon, ChevronRightIcon } from "@heroicons/vue/solid";

// Store
import { storeToRefs } from "pinia";
import { useSessionStore, useGlobalStore } from "@store";
import { computed } from "vue";

const sessionStore = useSessionStore();
const globalStore = useGlobalStore();
const { session } = storeToRefs(sessionStore);
const { isHomePage } = storeToRefs(globalStore);

const parentCode = computed(() => session?.value?.account?.parent);
</script>
